import { createAction } from '@reduxjs/toolkit';

export const CALL_HISTORY_CONTACTS_ACTION_TYPE = 'saga/processCallHistory';
export const callHistoryContactsAction = createAction(CALL_HISTORY_CONTACTS_ACTION_TYPE);
